export const WINDOW_OFFSET = 105;
